<template>
  <v-card class="py-3 px-3" outlined>
    <div v-if="loadingView">
      <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      <v-skeleton-loader
        type="table-heading, list-item-two-line, image, table-tfoot"
      ></v-skeleton-loader>
    </div>
    <div v-else>
      <v-card-title class="px-0 pt-0 pb-7">
        <v-row>
          <v-col cols="8" class="pb-3 pl-3">
            <span class="pb-2 primary--text">{{ formEditTitle }}</span>
          </v-col>
          <v-col cols="4" align="end" class="pt-2 text-right">
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="to-right" icon @click="closeModal">
                  <v-icon v-bind="attrs" v-on="on">{{ closeIcon }}</v-icon>
                </v-btn>
              </template>
              <span>Cerrar</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="px-0">
        <v-row>
          <v-col
            col="12"
            md="6"
            class="pt-0 pl-2 pr-0 pb-0"
            align="start"
            align-self="center"
          >
            <v-btn-toggle dense v-model="text" color="primary" group>
              <v-btn value="DATOS GENERALES" @click="switchTab(1)">
                Datos generales
              </v-btn>
              <v-btn :disabled="!clienteId" @click="switchTab(2)">
                Conexión
              </v-btn>
              <v-btn :disabled="!clienteId" @click="switchTab(3)">
                Configuración
              </v-btn>
              <v-btn :disabled="!clienteId" @click="switchTab(4)">
                Contactos
              </v-btn>
              <v-btn :disabled="!clienteId" @click="switchTab(5)">
                Versiones
              </v-btn>
              <v-btn :disabled="!clienteId" @click="switchTab(7)">
                Productos
              </v-btn>
              <v-btn :disabled="!clienteId" @click="switchTab(6)">
                Notas
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
        <v-row class="pt-2 pb-7">
          <v-col cols="1" class="py-0 pr-6">
            <v-text-field
              v-model="clienteId"
              dense
              label="Id"
              outlined
              class="center-input"
              disabled
              hide-details="true"
              autocomplete="off"
              filled
              readonly
            >
            </v-text-field>
          </v-col>
          <v-col cols="4" class="py-0 pl-0">
            <v-text-field
              v-model="clienteNombre"
              dense
              label="Nombre"
              outlined
              :hide-details="clienteNombre ? true : false"
              :readonly="tabOptions.tabId !== 1"
              :disabled="tabOptions.tabId !== 1"
              :filled="tabOptions.tabId !== 1"
              :rules="
                rules.required.concat(
                  [rules.maxLength(clienteNombre, 50)],
                  [rules.requiredTrim(clienteNombre)]
                )
              "
            >
            </v-text-field>
          </v-col>
          <v-col cols="3" class="py-0">
            <v-menu
              ref="menu-fecha-baja"
              v-model="menuFechaBaja"
              :close-on-content-click="false"
              :open-on-click="tabOptions.tabId == 1 ? true : false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="fechaBajaSelected"
                  label="Fecha baja"
                  :append-icon="calendarIcon"
                  v-bind="attrs"
                  outlined
                  hide-details="auto"
                  :readonly="tabOptions.tabId !== 1"
                  :disabled="tabOptions.tabId !== 1"
                  :filled="tabOptions.tabId !== 1"
                  clearable
                  dense
                  hint="Formato DD/MM/AAAA"
                  v-mask="'##/##/####'"
                  @blur="fechaBaja = parseDateToIso(fechaBajaSelected)"
                  v-on="on"
                  :rules="
                    fechaBajaSelected
                      ? rules.required.concat(rules.validDate)
                      : []
                  "
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fechaBaja"
                no-title
                :readonly="tabOptions.tabId !== 1"
                @change="fechaBajaSelected = formatDate(fechaBaja)"
                @input="menuFechaBaja = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="2" class="py-0">
            <v-autocomplete
              v-model="provinciaSelected"
              :items="provincias"
              label="Provincia"
              item-text="value"
              item-value="id"
              outlined
              dense
              hide-details="true"
            ></v-autocomplete>
          </v-col>
          <v-col cols="2" class="py-0">
            <v-text-field
              v-model="estado"
              hide-details="true"
              label="Estado"
              outlined
              solo
              filled
              readonly
              :background-color="getEstadoColor(estado)"
              dense
            >
            </v-text-field>
          </v-col>
        </v-row>
        <section
          v-if="tabOptions && tabOptions.tabId == 1"
          class="pt-2 pl-0 pb-0"
        >
          <v-row class="py-0">
            <v-col cols="4" class="py-0">
              <v-tooltip top :disabled="!razonSocial || razonSocial == ''" left>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="razonSocial"
                    hide-details="auto"
                    label="Razon social"
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    dense
                    :rules="[rules.maxLength(razonSocial, 250)]"
                  >
                  </v-text-field>
                </template>
                <span>{{ razonSocial }}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="5" class="py-0">
              <v-autocomplete
                v-model="equipoSoporteSelected"
                :items="equiposSoporte"
                item-text="value"
                item-value="id"
                label="Equipo de soporte"
                outlined
                autocomplete="off"
                clearable
                dense
                :rules="!sinSoporte ? rules.required : []"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="2" class="py-0">
              <v-menu
                ref="menu-fecha-licencia"
                v-model="menuFechaLicencia"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fechaLicenciaSelected"
                    label="Fecha licencia"
                    :append-icon="calendarIcon"
                    v-bind="attrs"
                    outlined
                    clearable
                    hide-details="true"
                    dense
                    :disabled="licenciaPerpetua"
                    :filled="licenciaPerpetua"
                    hint="Formato DD/MM/AAAA"
                    v-mask="'##/##/####'"
                    @blur="
                      fechaLicencia = parseDateToIso(fechaLicenciaSelected)
                    "
                    v-on="on"
                    :rules="
                      !licenciaPerpetua
                        ? rules.required.concat(rules.validDate)
                        : []
                    "
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fechaLicencia"
                  no-title
                  @change="fechaLicenciaSelected = formatDate(fechaLicencia)"
                  @input="menuFechaLicencia = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="2" class="pt-0 pb-2">
              <v-switch
                class="mt-0 mb-0"
                v-model="licenciaPerpetua"
                dense
                hide-details="true"
                outlined
                label="Lic. sin corte"
              >
              </v-switch>
            </v-col>
          </v-row>
          <v-row class="pt-0">
            <v-col cols="12" class="py-0">
              <v-textarea
                v-model="observaciones"
                label="Observaciones"
                dense
                auto-grow
                rows="1"
                outlined
              ></v-textarea>
            </v-col>
          </v-row>
        </section>
        <section v-if="tabOptions.tabId == 2">
          <v-row class="pt-7">
            <!-- Conexiones -->
            <v-col cols="12" md="12" class="py-0 mt-n2">
              <v-data-table
                class="elevation-2"
                :headers="headersDatosAcceso"
                :items="filterSoloActivosDatosAcceso"
                dense
                item-key="idDatos"
                :loading="isLoadingDatosAcceso"
                no-data-text="No hay datos disponibles para mostrar"
                :hide-default-footer="
                  itemsDatosAcceso.length > 10 ? false : true
                "
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-col cols="2" class="pl-0 pt-0" align="start">
                      <h4 class="primary--text">Datos de acceso</h4>
                    </v-col>
                    <v-col cols="5" class="py-0 my-0 pr-0">
                      <v-switch
                        class="mt-0"
                        v-model="soloActivosDatosAcceso"
                        label="Solo activos"
                        hide-details="true"
                        outlined
                      ></v-switch>
                    </v-col>
                    <v-col
                      cols="5"
                      class="pt-0 pb-0 pl-2 pr-0 text-right"
                      align="end"
                    >
                      <v-btn
                        v-if="canCreateDatosAcceso"
                        @click="addDatoAcceso()"
                        color="primary"
                        small
                      >
                        Nuevo
                      </v-btn>
                    </v-col>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.habilitado`]="{ item }">
                  <v-icon v-if="item.habilitado" small color="primary">
                    {{ checkIcon }}
                  </v-icon>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-if="canEditDatosAcceso"
                        v-bind="attrs"
                        size="20"
                        v-on="on"
                        @click="addDatoAcceso(item)"
                      >
                        {{ editIcon }}
                      </v-icon>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-if="canDeleteDatosAcceso"
                        v-bind="attrs"
                        size="20"
                        v-on="on"
                        @click="deleteDatosAcceso(item)"
                      >
                        {{ deleteIcon }}
                      </v-icon>
                    </template>
                    <span>Eliminar</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <v-row class="pt-3">
            <!-- Conexiones -->
            <v-col cols="12" md="12" class="py-0 mt-n2">
              <v-data-table
                class="elevation-2"
                :headers="headersConexiones"
                :items="filterSoloActivosConexiones"
                dense
                :loading="isLoadingConexiones"
                item-key="id"
                no-data-text="No hay datos disponibles para mostrar"
                :hide-default-footer="
                  itemsConexiones.length > 10 ? false : true
                "
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-col cols="2" align="start" class="pl-0 pt-0">
                      <h4 class="pl-0 primary--text">Conexiones RDP</h4>
                    </v-col>
                    <v-col cols="5" class="py-0 my-0 pr-0">
                      <v-switch
                        class="mt-0"
                        v-model="soloActivosConexiones"
                        label="Solo activos"
                        hide-details="true"
                        outlined
                      ></v-switch>
                    </v-col>
                    <v-col
                      cols="5"
                      class="pt-0 pb-0 pl-2 pr-0 text-right"
                      align="end"
                    >
                      <v-btn
                        v-if="canCreateConexionRDP"
                        @click="editConexion()"
                        color="primary"
                        small
                      >
                        Nuevo
                      </v-btn>
                    </v-col>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.habilitado`]="{ item }">
                  <v-icon v-if="item.habilitado" small color="primary">
                    {{ checkIcon }}
                  </v-icon>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-if="canEditConexionRDP"
                        v-bind="attrs"
                        size="20"
                        v-on="on"
                        @click="editConexion(item)"
                      >
                        {{ editIcon }}
                      </v-icon>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-if="canDeleteConexionRDP"
                        v-bind="attrs"
                        size="20"
                        v-on="on"
                        @click="deleteConexion(item)"
                      >
                        {{ deleteIcon }}
                      </v-icon>
                    </template>
                    <span>Eliminar</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </section>
        <section v-if="tabOptions.tabId == 3">
          <v-row class="pt-6">
            <!-- Servidores -->
            <v-col cols="12" md="12" class="py-0 mt-n2">
              <v-data-table
                class="elevation-2"
                :headers="headersServidores"
                :items="itemsServidores"
                dense
                :expanded.sync="expandedServidores"
                show-expand
                item-key="servidoresClientesId"
                no-data-text="No hay datos disponibles para mostrar"
                :hide-default-footer="
                  itemsServidores.length > 10 ? false : true
                "
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-col cols="6" class="pl-0 pt-0">
                      <h4 class="pl-0 primary--text">Servidores</h4>
                    </v-col>
                    <v-col
                      cols="6"
                      class="pt-0 pb-0 pl-2 pr-0 text-right"
                      align="end"
                    >
                      <v-btn
                        @click="
                          itemsServidores.push({
                            descripcion: '',
                            servidorNombre: '',
                            servidorTipoId: null,
                            servidorIp: '',
                          })
                        "
                        color="primary"
                        small
                      >
                        Nuevo
                      </v-btn>
                    </v-col>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.servidorNombre`]="{ item }">
                  <td class="px-0 py-0">
                    <v-autocomplete
                      v-model="item.tipoServidorToEdit"
                      :items="itemsTipoServidores"
                      item-text="value"
                      item-value="id"
                      style="font-size: 0.9rem; max-width: 170px"
                      return-object
                      rounded
                      dense
                      @change="
                        () => {
                          item.servidorNombre = item.tipoServidorToEdit.value;
                          item.servidorTipoId = item.tipoServidorToEdit.id;
                          if (!camposEditados.includes('datosServidores'))
                            camposEditados.push('datosServidores');
                        }
                      "
                      hide-details="true"
                    ></v-autocomplete>
                  </td>
                </template>
                <template v-slot:[`item.descripcion`]="{ item }">
                  <td class="px-0 py-0">
                    <v-textarea
                      v-model="item.descripcion"
                      dense
                      style="font-size: 0.9rem"
                      hide-details="true"
                      rounded
                      :rows="item.descripcion.length > 60 ? 5 : 2"
                      :rules="
                        rules.required.concat(
                          [rules.maxLength(item.descripcion, 50)],
                          [rules.requiredTrim(item.descripcion)]
                        )
                      "
                      @change="
                        () => {
                          if (!camposEditados.includes('datosServidores'))
                            camposEditados.push('datosServidores');
                        }
                      "
                    >
                    </v-textarea>
                  </td>
                </template>
                <template v-slot:[`item.servidorIp`]="{ item }">
                  <td class="px-0 py-0">
                    <v-text-field
                      v-model="item.servidorIp"
                      dense
                      style="font-size: 0.9rem; max-width: 160px"
                      hide-details="true"
                      rounded
                      @change="
                        () => {
                          if (!camposEditados.includes('datosServidores'))
                            camposEditados.push('datosServidores');
                        }
                      "
                    >
                    </v-text-field>
                  </td>
                </template>
                <template v-slot:[`item.delete`]="{ item }">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        size="20"
                        v-on="on"
                        @click="
                          () => {
                            itemsServidores = itemsServidores.filter(
                              (x) => x !== item
                            );
                            if (!camposEditados.includes('datosServidores'))
                              camposEditados.push('datosServidores');
                          }
                        "
                      >
                        {{ deleteIcon }}
                      </v-icon>
                    </template>
                    <span>Eliminar</span>
                  </v-tooltip>
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">
                    <strong>Fecha alta:</strong>
                    {{ item.fecAltaToShow }}
                    <strong style="padding-left: 80px">Usuario alta:</strong>
                    {{ item.usuAlta }}
                    <strong style="padding-left: 80px"
                      >Fecha modificación:</strong
                    >
                    {{ item.fecModiToShow }}
                    <strong style="padding-left: 80px"
                      >Usuario modificación:</strong
                    >
                    {{ item.usuModi }}
                  </td>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <v-row class="pt-4">
            <!-- Sitios web -->
            <v-col cols="12" md="12" class="py-0 mt-n2">
              <v-data-table
                class="elevation-2 sitios-web-table"
                :headers="headersSitios"
                :items="filteredItemsSitios"
                :search="searchSitios"
                :custom-filter="filterSitios"
                :expanded.sync="expandedSitios"
                dense
                item-key="sitioLocalId"
                :item-class="getSitioRowClass"
                no-data-text="No hay datos disponibles para mostrar"
                :hide-default-footer="
                  filteredItemsSitios.length > 10 ? false : true
                "
                @click:row="toggleSitioExpanded"
              >
                <template v-slot:top>
                  <div class="sitios-table-toolbar">
                    <div class="sitios-table-header">
                      <h4 class="pl-0 primary--text mb-0">Sitios</h4>
                      <v-btn
                        @click="openNewSitioEditor"
                        color="primary"
                        small
                      >
                        Nuevo
                      </v-btn>
                    </div>
                    <div class="sitios-filters">
                      <v-text-field
                        v-model="searchSitios"
                        append-icon="mdi-magnify"
                        label="Buscar"
                        single-line
                        hide-details
                        dense
                        clearable
                        class="sitios-search"
                      ></v-text-field>
                      <v-autocomplete
                        v-model="sistemaSitiosSelected"
                        :items="itemsSistemas"
                        item-text="value"
                        item-value="id"
                        label="Sistema"
                        hide-details
                        dense
                        clearable
                        class="sitios-system-filter"
                      ></v-autocomplete>
                    </div>
                  </div>
                </template>
                <template v-slot:[`item.sistemaNombre`]="{ item }">
                  <div class="sitio-main-cell">
                    <span
                      class="sitio-main-text"
                      v-html="
                        highlightSitioText(
                          item.sitioNombre || 'Sin sitio seleccionado'
                        )
                      "
                    ></span>
                    <span
                      class="sitio-secondary-text"
                      v-html="highlightSitioText(item.sistemaNombre || '-')"
                    ></span>
                  </div>
                </template>
                <template v-slot:[`item.descripcion`]="{ item }">
                  <span
                    v-html="highlightSitioText(item.descripcion || '-')"
                  ></span>
                </template>
                <template v-slot:[`item.habilitado`]="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div
                        class="sitio-status-switch"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop
                      >
                        <v-switch
                          v-model="item.habilitado"
                          class="mt-0 pt-0"
                          dense
                          inset
                          hide-details="true"
                          @change="markDatosSitiosChanged"
                        />
                      </div>
                    </template>
                    <span>
                      Define si el sitio participa en configuraciones y
                      actualizaciones activas.
                    </span>
                  </v-tooltip>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        size="20"
                        v-on="on"
                        class="mr-2"
                        @click.stop="openEditSitioEditor(item)"
                      >
                        {{ editIcon }}
                      </v-icon>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        size="20"
                        v-on="on"
                        @click.stop="removeSitio(item)"
                      >
                        {{ deleteIcon }}
                      </v-icon>
                    </template>
                    <span>Eliminar</span>
                  </v-tooltip>
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length" class="sitio-detail-row">
                    <div
                      v-if="getSitioDetailFields(item).length"
                      class="sitio-detail-table-wrap"
                    >
                      <table class="sitio-detail-table">
                        <thead>
                          <tr>
                            <th
                              v-for="field in getSitioDetailFields(item)"
                              :key="`header-${field.label}`"
                            >
                              {{ field.label }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td
                              v-for="field in getSitioDetailFields(item)"
                              :key="`value-${field.label}`"
                            >
                              <span
                                v-if="field.sensitive"
                                class="sitio-sensitive-value"
                              >
                                <span>
                                  {{
                                    isSitioCadenaVisible(item)
                                      ? field.value
                                      : getMaskedValue(field.value)
                                  }}
                                </span>
                                <v-icon
                                  v-if="canSeeUsuarioAvanzado"
                                  small
                                  color="grey darken-1"
                                  @click.stop="toggleSitioCadenaVisible(item)"
                                >
                                  {{
                                    isSitioCadenaVisible(item)
                                      ? "mdi-eye-off"
                                      : "mdi-eye"
                                  }}
                                </v-icon>
                              </span>
                              <span
                                v-else
                                v-html="highlightSitioText(field.value)"
                              ></span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-else class="sitio-detail-empty">
                      Sin datos adicionales cargados
                    </div>
                  </td>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <v-row class="pt-4">
            <v-col cols="12" class="py-0 mt-n2">
              <v-card class="elevation-2">
                <v-toolbar flat>
                  <v-col cols="12" class="pl-0 pt-0">
                    <h4 class="pl-0 primary--text">
                      Configuración de actualizaciones
                    </h4>
                  </v-col>
                </v-toolbar>
                <v-card-text class="pt-0 pb-3">
                  <v-text-field
                    v-model="rutaDescargaPaquetes"
                    label="Carpeta destino de descargas de paquetes"
                    outlined
                    dense
                    hide-details="auto"
                    @change="
                      () => {
                        if (!camposEditados.includes('configActualizaciones'))
                          camposEditados.push('configActualizaciones');
                      }
                    "
                  ></v-text-field>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-data-table
                class="elevation-2"
                :headers="headersUsuariosBasicos"
                :items="itemsUsuariosBasicos"
                dense
                item-key="clientexTipoIsId"
                :hide-default-footer="
                  itemsUsuariosBasicos.length > 10 ? false : true
                "
                no-data-text="No hay datos disponibles para mostrar"
              >
                <template v-slot:[`item.tipoId.value`]="{ item }">
                  <td class="px-0">
                    <v-autocomplete
                      :disabled="!canEditUsuarioBasico && !item.isNew"
                      :filled="!canEditUsuarioBasico && !item.isNew"
                      v-model="item.tipoId"
                      :items="tipoUsersBasicos"
                      item-text="value"
                      item-value="id"
                      :rules="[...rules.required]"
                      :rounded="canEditUsuarioBasico || item.isNew"
                      style="font-size: 0.9rem"
                      hide-details="true"
                      return-object
                      dense
                    >
                    </v-autocomplete>
                  </td>
                </template>
                <template v-slot:[`item.credencial`]="{ item }">
                  <td class="px-0">
                    <v-text-field
                      :disabled="!canEditUsuarioBasico && !item.isNew"
                      :filled="!canEditUsuarioBasico && !item.isNew"
                      v-model="item.credencial"
                      :rules="[...rules.required]"
                      dense
                      style="font-size: 0.9rem"
                      hide-details="true"
                      :rounded="canEditUsuarioBasico || item.isNew"
                      @change="
                        () => {
                          if (!camposEditados.includes('datosUsuarios'))
                            camposEditados.push('datosUsuarios');
                        }
                      "
                    >
                    </v-text-field>
                  </td>
                </template>
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-row>
                      <v-col cols="10" class="pl-2 pt-2">
                        <h4 class="pl-0 primary--text">Usuarios básicos</h4>
                      </v-col>
                      <v-col cols="2" align="end" class="pt-5 text-right">
                        <v-btn
                          v-if="canCreateUsuarioBasico"
                          color="primary"
                          small
                          @click="itemsUsuariosBasicos.push({ isNew: true })"
                          class="to-right"
                        >
                          Nuevo
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-if="canDeleteUsuarioBasico"
                        v-bind="attrs"
                        size="20"
                        v-on="on"
                        @click="
                          () => {
                            itemsUsuariosBasicos = itemsUsuariosBasicos.filter(
                              (x) => x !== item
                            );
                            if (!camposEditados.includes('datosUsuarios'))
                              camposEditados.push('datosUsuarios');
                          }
                        "
                      >
                        {{ deleteIcon }}
                      </v-icon>
                    </template>
                    <span>Eliminar usuario</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
            <v-col
              v-if="permisos.canAccesoAvanzados && canSeeUsuarioAvanzado"
              cols="12"
            >
              <v-data-table
                class="elevation-2"
                :headers="headersUsuariosAvanzados"
                :items="itemsUsuariosAvanzados"
                dense
                item-key="clientexTipoIsId"
                :hide-default-footer="
                  itemsUsuariosAvanzados.length > 10 ? false : true
                "
                no-data-text="No hay datos disponibles para mostrar"
              >
                <template v-slot:[`item.tipoId.value`]="{ item }">
                  <td class="px-0">
                    <v-autocomplete
                      :disabled="!canEditUsuarioAvanzado && !item.isNew"
                      :filled="!canEditUsuarioAvanzado && !item.isNew"
                      :rounded="canEditUsuarioAvanzado || item.isNew"
                      v-model="item.tipoId"
                      :items="tipoUsersAvanzados"
                      style="font-size: 0.9rem"
                      item-text="value"
                      item-value="id"
                      :rules="[...rules.required]"
                      hide-details="true"
                      return-object
                      dense
                    >
                    </v-autocomplete>
                  </td>
                </template>
                <template v-slot:[`item.credencial`]="{ item }">
                  <td class="px-0">
                    <v-text-field
                      :disabled="!canEditUsuarioAvanzado && !item.isNew"
                      :filled="!canEditUsuarioAvanzado && !item.isNew"
                      :rounded="canEditUsuarioAvanzado || item.isNew"
                      v-model="item.credencial"
                      :rules="[...rules.required]"
                      dense
                      style="font-size: 0.9rem; color: black"
                      hide-details="true"
                      @change="
                        () => {
                          if (!camposEditados.includes('datosUsuarios'))
                            camposEditados.push('datosUsuarios');
                        }
                      "
                    >
                    </v-text-field>
                  </td>
                </template>
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-row>
                      <v-col cols="10" class="pl-2 pt-2">
                        <h4 class="pl-0 primary--text">Usuarios avanzados</h4>
                      </v-col>
                      <v-col cols="2" align="end" class="pt-5 text-right">
                        <v-btn
                          v-if="canCreateUsuarioAvanzado"
                          color="primary"
                          small
                          @click="itemsUsuariosAvanzados.push({ isNew: true })"
                          class="to-right"
                        >
                          Nuevo
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-if="canDeleteUsuarioAvanzado"
                        v-bind="attrs"
                        size="20"
                        v-on="on"
                        @click="
                          () => {
                            itemsUsuariosAvanzados =
                              itemsUsuariosAvanzados.filter((x) => x !== item);
                            if (!camposEditados.includes('datosUsuarios'))
                              camposEditados.push('datosUsuarios');
                          }
                        "
                      >
                        {{ deleteIcon }}
                      </v-icon>
                    </template>
                    <span>Eliminar usuario</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </section>
        <section v-if="tabOptions.tabId == 4">
          <v-row v-if="canGestionarContactos">
            <v-col cols="12">
              <v-data-table
                class="elevation-2 mt-6"
                :headers="headersContacto"
                :items="itemsContacto"
                item-key="contactoId"
                :loading="isLoadingContactos"
                no-data-text="No hay datos disponibles para mostrar"
                :hide-default-footer="itemsContacto.length > 10 ? false : true"
                dense
              >
                <template v-slot:[`item.informarActualizacion`]="{ item }">
                  <v-icon
                    v-if="item.informarActualizacion"
                    small
                    color="primary"
                  >
                    {{ checkIcon }}
                  </v-icon>
                </template>
                <template v-slot:[`item.esReferente`]="{ item }">
                  <v-icon v-if="item.esReferente" small color="primary">
                    {{ checkIcon }}
                  </v-icon>
                </template>
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-row>
                      <v-col cols="10" class="pl-2 pt-2">
                        <h4 class="pl-0 primary--text">Contactos</h4>
                      </v-col>
                      <v-col cols="2" align="end" class="pt-5 text-right">
                        <v-btn
                          color="primary"
                          small
                          @click="editContacto()"
                          class="to-right"
                        >
                          Nuevo
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        size="20"
                        v-on="on"
                        @click="editContacto(item)"
                      >
                        {{ editIcon }}
                      </v-icon>
                    </template>
                    <span>Editar contacto</span>
                  </v-tooltip>
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        size="20"
                        v-on="on"
                        @click="deleteContacto(item)"
                      >
                        {{ deleteIcon }}
                      </v-icon>
                    </template>
                    <span>Eliminar contacto</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </section>
        <section v-if="tabOptions.tabId == 5">
          <v-row>
            <v-col class="py-0">
              <v-data-table
                :loading="loadingVersiones"
                class="elevation-2 mt-0"
                dense
                :headers="headersVersiones"
                :items="itemsVersiones"
                :hide-default-footer="itemsVersiones.length > 10 ? false : true"
                no-data-text="No hay datos disponibles para mostrar"
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-row align="center" class="ma-0">
                      <v-col cols="12" md="3" class="py-0 pl-0 pr-3">
                        <v-autocomplete
                          v-model="sistemaSelected"
                          :items="itemsSistemas"
                          item-text="value"
                          item-value="id"
                          outlined
                          return-object
                          dense
                          autocomplete="off"
                          hide-details="true"
                          label="Sistemas"
                          @change="getVersiones"
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="5" class="py-0 px-0">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <div
                              v-bind="attrs"
                              v-on="on"
                              class="d-inline-block"
                            >
                              <v-switch
                                v-model="permiteVersionesNoValidadas"
                                @change="savePermiteVersionesNoValidadas"
                                :disabled="isSavingPermiteVersionesNoValidadas"
                                :loading="isSavingPermiteVersionesNoValidadas"
                                class="mt-0"
                                dense
                                hide-details="true"
                                label="Permitir versiones no validadas"
                              ></v-switch>
                            </div>
                          </template>
                          <span>
                            Habilita versiones no terminadas de desarrollar o
                            en fase de validacion para este cliente. Usar solo
                            en entornos no productivos.
                          </span>
                        </v-tooltip>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                        class="py-0 pr-0 text-right"
                        align="end"
                      >
                      <v-btn
                        v-if="canCreateVersion"
                        @click="openModalNewVersion()"
                        color="primary"
                        small
                      >
                        Nuevo
                      </v-btn>
                      </v-col>
                    </v-row>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-if="canViewActualizacionesClientes"
                        v-bind="attrs"
                        size="20"
                        v-on="on"
                        @click="openActualizacionVersion(item)"
                      >
                        {{ historyIcon }}
                      </v-icon>
                    </template>
                    <span>Ver actualizacion</span>
                  </v-tooltip>
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        size="20"
                        v-on="on"
                        @click="openModalNewVersion(item)"
                      >
                        {{ editIcon }}
                      </v-icon>
                    </template>
                    <span>Editar versión</span>
                  </v-tooltip>
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        size="20"
                        v-on="on"
                        @click="openModalDeleteVersion(item.versionClienteId)"
                      >
                        {{ deleteIcon }}
                      </v-icon>
                    </template>
                    <span>Eliminar versión</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </section>
        <section v-if="tabOptions.tabId == 6">
          <v-data-table
            class="elevation-2 mt-6"
            :headers="headerNotas"
            :items="itemsNotas"
            dense
            item-key="notaId"
            no-data-text="No hay datos disponibles para mostrar"
            :hide-default-footer="itemsNotas.length > 10 ? false : true"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-row class="mt-n5">
                  <v-col cols="10" class="pl-2 pt-2">
                    <h4 class="pl-0 primary--text">Notas</h4>
                  </v-col>
                  <v-col cols="2" align="end" class="text-right">
                    <v-btn
                      color="primary"
                      small
                      v-if="canCreateGestionarNotas"
                      @click="editNota()"
                      class="to-right"
                    >
                      Nuevo
                    </v-btn>
                  </v-col>
                </v-row>
              </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    size="20"
                    v-if="canEditGestionarNotas"
                    v-on="on"
                    @click="editNota(item)"
                  >
                    {{ editIcon }}
                  </v-icon>
                </template>
                <span>Editar nota</span>
              </v-tooltip>
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    size="20"
                    v-if="canDeleteGestionarNotas"
                    v-on="on"
                    @click="openModalDeleteNota(item)"
                  >
                    {{ deleteIcon }}
                  </v-icon>
                </template>
                <span>Eliminar nota</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </section>
        <section v-if="tabOptions.tabId == 7">
          <v-data-table
            class="elevation-2 mt-6"
            :headers="headersProductos"
            :items="itemsProductos"
            :loading="isLoadingProductos"
            dense
            item-key="productoLocalId"
            no-data-text="No hay datos disponibles para mostrar"
            :hide-default-footer="itemsProductos.length > 10 ? false : true"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-row class="mt-n5">
                  <v-col cols="10" class="pl-2 pt-2">
                    <h4 class="pl-0 primary--text">Productos</h4>
                  </v-col>
                  <v-col cols="2" align="end" class="text-right">
                    <v-btn
                      color="primary"
                      small
                      @click="addProducto"
                      class="to-right"
                    >
                      Nuevo
                    </v-btn>
                  </v-col>
                </v-row>
              </v-toolbar>
            </template>
            <template v-slot:[`item.codigo`]="{ item }">
              <td class="px-0 py-0">
                <v-select
                  v-model="item.codigo"
                  :items="productosContratadosOptions"
                  item-text="descripcion"
                  item-value="codigo"
                  dense
                  rounded
                  style="font-size: 0.9rem"
                  hide-details="true"
                  :rules="rules.required"
                ></v-select>
              </td>
            </template>
            <template v-slot:[`item.guid`]="{ item }">
              <td class="px-0 py-0 producto-guid-cell">
                <v-text-field
                  v-model="item.guid"
                  dense
                  rounded
                  style="font-size: 0.9rem"
                  hide-details="true"
                  :rules="rules.required.concat(rules.validGuid)"
                ></v-text-field>
              </td>
            </template>
            <template v-slot:[`item.implementado`]="{ item }">
              <div class="producto-switch-cell">
                <v-switch
                  v-model="item.implementado"
                  class="mt-0 mb-0"
                  dense
                  hide-details="true"
                ></v-switch>
              </div>
            </template>
            <template v-slot:[`item.ubic_id`]="{ item }">
              <td class="px-0 py-0">
                <v-text-field
                  v-model.number="item.ubic_id"
                  dense
                  rounded
                  type="number"
                  class="producto-ubicacion-input"
                  style="font-size: 0.9rem"
                  hide-details="true"
                  min="0"
                ></v-text-field>
              </td>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    size="20"
                    v-on="on"
                    @click="removeProducto(item)"
                  >
                    {{ deleteIcon }}
                  </v-icon>
                </template>
                <span>Eliminar producto</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </section>
      </v-card-text>
      <v-card-actions class="pr-0 pb-0 pt-0">
        <span v-if="tabOptions.tabId == 3">
          Aclaración: Todos los cambios realizados en esta pestaña se
          reemplazarán al guardar configuración
        </span>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          v-if="
            tabOptions.tabId == 3 ||
            tabOptions.tabId == 1 ||
            tabOptions.tabId == 7
          "
          @click="saveDatosCliente"
          :disabled="disabledBtnSave"
          form="form"
          :loading="isLoading"
        >
          Guardar
        </v-btn>
      </v-card-actions>
    </div>
    <v-dialog
      v-model="siteEditorDialog"
      max-width="760px"
      persistent
      @keydown.esc="closeSitioEditor"
    >
      <v-card outlined>
        <v-card-title class="primary--text">
          {{ siteEditorTitle }}
        </v-card-title>
        <v-card-text class="pb-2">
          <v-form
            ref="siteForm"
            v-model="siteEditorValid"
            @submit.prevent="confirmSitioEditor"
          >
            <v-row>
              <v-col cols="12" md="6" class="py-0">
                <v-autocomplete
                  v-model="siteEditorItem.sistemaToEdit"
                  :items="itemsSistemas"
                  item-text="value"
                  item-value="id"
                  label="Sistema"
                  :rules="[...rules.required]"
                  outlined
                  dense
                  return-object
                  autocomplete="off"
                  @change="onSiteEditorSistemaChange"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <v-autocomplete
                  v-model="siteEditorItem.sitioToEdit"
                  :items="siteEditorItem.itemsSitiosBySistema"
                  item-text="value"
                  item-value="id"
                  label="Sitio"
                  :rules="[...rules.required]"
                  outlined
                  dense
                  return-object
                  autocomplete="off"
                  :disabled="!siteEditorItem.sistemaToEdit"
                  @change="onSiteEditorSitioChange"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" class="py-0">
                <v-text-field
                  v-model="siteEditorItem.descripcion"
                  label="Descripción"
                  outlined
                  dense
                  :rules="
                    rules.required.concat(
                      [rules.requiredTrim(siteEditorItem.descripcion)]
                    )
                  "
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  v-model="siteEditorItem.rutaDestino"
                  label="Ruta destino"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  v-model="siteEditorItem.carpetaBackup"
                  label="Carpeta backup"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  v-model="siteEditorItem.nombreSitioIIS"
                  label="Sitio IIS"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  v-model="siteEditorItem.nombrePoolIIS"
                  label="Pool IIS"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  v-model.number="siteEditorItem.puertoIIS"
                  label="Puerto IIS"
                  type="number"
                  outlined
                  dense
                  :rules="[
                    rules.minMaxNumber(siteEditorItem.puertoIIS, 0, 65535),
                  ]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  v-model="siteEditorItem.cadenaConexion"
                  label="Cadena conexión"
                  :type="showSiteEditorCadenaConexion ? 'text' : 'password'"
                  :append-icon="
                    canSeeUsuarioAvanzado
                      ? showSiteEditorCadenaConexion
                        ? 'mdi-eye-off'
                        : 'mdi-eye'
                      : ''
                  "
                  outlined
                  dense
                  @click:append="
                    showSiteEditorCadenaConexion =
                      !showSiteEditorCadenaConexion
                  "
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="py-0">
                <div class="sitio-enabled-row">
                  <v-switch
                    v-model="siteEditorItem.habilitado"
                    label="Habilitado"
                    class="mt-0"
                    dense
                    inset
                    hide-details="true"
                  ></v-switch>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        small
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>
                      Define si el sitio participa en configuraciones y
                      actualizaciones activas.
                    </span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined @click="closeSitioEditor">Cancelar</v-btn>
          <v-btn
            color="primary"
            :disabled="!siteEditorValid || isSavingSitio"
            :loading="isSavingSitio"
            @click="confirmSitioEditor"
          >
            Guardar sitio
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="openEditDatoConexion"
      v-model="openEditDatoConexion"
      max-width="55%"
      persistent
      @keydown.esc="openEditDatoConexion = false"
    >
      <EditConexionRdp
        :registrosParams="itemConexion"
        :idReg="clienteId"
        @closeAndReload="closeAndReloadConexiones($event)"
      >
      </EditConexionRdp>
    </v-dialog>
    <v-dialog
      v-if="openEditContactos"
      v-model="openEditContactos"
      max-width="55%"
      persistent
      @keydown.esc="openEditContactos = false"
    >
      <EditContactoCliente
        :clienteId="clienteId"
        :contactoId="contactoId"
        @closeAndReload="closeAndReloadContactos($event)"
      >
      </EditContactoCliente>
    </v-dialog>
    <v-dialog
      v-if="openNotaCliente"
      v-model="openNotaCliente"
      max-width="83%"
      persistent
      @keydown.esc="openNotaCliente = false"
    >
      <EditNotaCliente
        @closeAndReload="closeAndReloadNotas()"
        :notaItemToEdit="notaItemToEdit"
        :clienteId="clienteId"
      >
      </EditNotaCliente>
    </v-dialog>
    <v-dialog
      v-if="openEditDatoAcceso"
      v-model="openEditDatoAcceso"
      max-width="55%"
      persistent
      @keydown.esc="openEditDatoAcceso = false"
    >
      <EditAccesoDatos
        :registrosParams="itemDatoAcceso ?? null"
        :idReg="clienteId"
        @closeAndReload="closeAndReloadDatosAcceso"
      >
      </EditAccesoDatos>
    </v-dialog>
    <v-dialog
      v-if="modalNewVersion"
      v-model="modalNewVersion"
      max-width="55%"
      persistent
      @keydown.esc="modalNewVersion = false"
    >
      <EditVersionCliente
        :clienteId="clienteId"
        :itemVersion="itemVersion"
        @closeAndReload="closeAndReloadVersiones"
      >
      </EditVersionCliente>
    </v-dialog>
    <v-dialog
      v-if="openActualizacionModal"
      v-model="openActualizacionModal"
      max-width="92%"
      persistent
      @keydown.esc="openActualizacionModal = false"
    >
      <ActualizacionVersionCliente
        :cliente-id="actualizacionVersionItem.clienteId"
        :version-id="actualizacionVersionItem.versionId"
        @close="openActualizacionModal = false"
      ></ActualizacionVersionCliente>
    </v-dialog>
    <DeleteDialog
      max-width="55%"
      :titleProp="titleDelete"
      :openDelete.sync="showDeleteModalDatoAcceso"
      :isLoading="isLoadingDatosAcceso"
      @onDeleteItem="confirmDeleteDatosAcceso()"
    />
    <DeleteDialog
      max-width="55%"
      :titleProp="titleDelete"
      :openDelete.sync="showDeleteModalConexion"
      :isLoading="isLoadingConexiones"
      @onDeleteItem="confirmDeleteConexion()"
    />
    <DeleteDialog
      max-width="55%"
      :titleProp="titleDelete"
      :openDelete.sync="showDeleteModalContacto"
      :isLoading="isLoadingContactos"
      @onDeleteItem="confirmDeleteContacto()"
    />
    <DeleteDialog
      max-width="55%"
      :titleProp="titleDelete"
      :openDelete.sync="showDeleteModalVersion"
      :isLoading="isLoadingVersion"
      @onDeleteItem="confirmDeleteVersion()"
    />
    <DeleteDialog
      max-width="50%"
      :titleProp="titleDelete"
      :openDelete.sync="showDeleteModalNotas"
      :isLoading="isLoadingNotas"
      @onDeleteItem="confirmDeleteNota()"
    />
    <DeleteDialog
      max-width="50%"
      :titleProp="titleDelete"
      :textDelete="discardChangesText"
      confirmButtonText="Salir"
      :openDelete.sync="showDiscardProductosChangesModal"
      @onDeleteItem="confirmCloseWithoutSaving()"
    />
    <DeleteDialog
      max-width="50%"
      :titleProp="titleDelete"
      textDelete="Al guardar se eliminarán los productos quitados de la lista."
      confirmButtonText="Guardar"
      :openDelete.sync="showConfirmSaveProductosDeleteModal"
      :isLoading="isLoadingProductos"
      @onDeleteItem="confirmSaveProductosConEliminados()"
    />
  </v-card>
</template>
  
<script>
import { mapActions } from "vuex";
import rules from "@/utils/helpers/rules";
import { mask } from "vue-the-mask";
import enums from "@/utils/enums/index.js";
import EditConexionRdp from "@/views/EditConexionRdp.vue";
import EditContactoCliente from "../views/EditContactoCliente.vue";
import EditNotaCliente from "../views/EditNotaCliente.vue";
import EditAccesoDatos from "../views/EditAccesoDatos.vue";
import DeleteDialog from "@/components/shared/DeleteDialog";
import enumsAdmin from "@/utils/enums/modules/index.js";
import webSiteOptions from "../utils/enums/modules/webSiteOptions";
import EditVersionCliente from "@/components/ui/EditVersionCliente";
import ActualizacionVersionCliente from "@/components/ActualizacionVersionCliente.vue";

export default {
  name: "NewEditCliente",
  components: {
    EditConexionRdp,
    EditContactoCliente,
    EditNotaCliente,
    EditAccesoDatos,
    DeleteDialog,
    EditVersionCliente,
    ActualizacionVersionCliente,
  },
  directives: { mask },
  props: {
    clienteId: {
      type: Number,
      required: false,
    },
    permisos: {
      type: Object,
      required: true,
    },
  },
  computed: {
    siteEditorTitle() {
      return this.siteEditorIndex === null ? "Nuevo sitio web" : "Editar sitio web";
    },
    disabledBtnSave() {
      if (this.tabOptions.tabId == 1) {
        if (
          !this.clienteNombre ||
          !this.provinciaSelected ||
          !this.equipoSoporteSelected ||
          !this.fechaLicencia ||
          !this.observaciones
        ) {
          return true;
        } else return false;
      }
      if (this.tabOptions.tabId == 3) {
        let errorServidores = this.itemsServidores.some(
          (x) => !x.tipoServidorToEdit || x.descripcion?.trim() == ""
        );
        let errorSitios = this.itemsSitios.some(
          (x) =>
            x.sistemaToEdit == null ||
            !x.sistemaToEdit ||
            x.descripcion?.trim() == "" ||
            !x.sitioToEdit
        );
        let errorUsuariosB = this.itemsUsuariosBasicos.some(
          (x) => x.credencial?.trim() == "" || !x.credencial || x.tipoId == null
        );
        let errorUsuariosA = this.itemsUsuariosAvanzados.some(
          (x) => x.credencial?.trim() == "" || !x.credencial || x.tipoId == null
        );
        if (
          errorServidores ||
          errorSitios ||
          errorUsuariosB ||
          errorUsuariosA
        ) {
          return true;
        } else return false;
      }
      if (this.tabOptions.tabId == 7) {
        const productosInvalidos = this.itemsProductos.some(
          (x) =>
            !x.codigo ||
            x.codigo.trim() == "" ||
            x.codigo.length > 100 ||
            !x.guid ||
            !/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
              x.guid
            ) ||
            !this.isProductoUbicacionValida(x.ubic_id)
        );

        return productosInvalidos || this.hasProductosDuplicados;
      }
      return false;
    },
    hasProductosDuplicados() {
      const keys = new Set();

      return this.itemsProductos.some((producto) => {
        const key = this.getProductoContratadoKey(producto);

        if (keys.has(key)) return true;

        keys.add(key);
        return false;
      });
    },
    hasProductosChanges() {
      return this.getProductosSnapshot() !== this.productosOriginalSnapshot;
    },
    hasUnsavedChanges() {
      return this.camposEditados.length > 0 || this.hasProductosChanges;
    },
    discardChangesText() {
      return "Hay cambios sin guardar. Si salís ahora, se perderán.";
    },
    filterSoloActivosConexiones() {
      if (this.soloActivosConexiones) {
        return this.itemsConexiones.filter((x) => x.habilitado === true);
      } else return this.itemsConexiones;
    },
    filterSoloActivosDatosAcceso() {
      if (this.soloActivosDatosAcceso) {
        return this.itemsDatosAcceso.filter((x) => x.habilitado === true);
      } else return this.itemsDatosAcceso;
    },
    filteredItemsSitios() {
      if (!this.sistemaSitiosSelected) return this.itemsSitios;

      return this.itemsSitios.filter(
        (sitio) => `${sitio.sistemaId}` === `${this.sistemaSitiosSelected}`
      );
    },
    headersSitiosToShow() {
      const hasSql = this.itemsSitios.some((x) => this.isSitioSql(x));
      const hasApplication = this.itemsSitios.some((x) =>
        this.isSitioApplication(x)
      );
      const hasIis = this.itemsSitios.some((x) => this.isSitioIis(x));
      const sqlOnlyColumns = ["cadenaConexion"];
      const applicationColumns = ["rutaDestino", "carpetaBackup"];
      const iisColumns = ["nombreSitioIIS", "nombrePoolIIS", "puertoIIS"];

      return this.headersSitios.filter((header) => {
        if (!hasSql && sqlOnlyColumns.includes(header.value)) return false;
        if (!hasApplication && applicationColumns.includes(header.value))
          return false;
        if (!hasIis && iisColumns.includes(header.value)) return false;
        return true;
      });
    },
  },
  data() {
    return {
      rules: rules,
      text: "DATOS GENERALES",
      formEditTitle: "Nuevo cliente",
      closeIcon: enums.icons.CLOSE,
      checkIcon: enums.icons.CHECK_OUTLINE,
      editIcon: enums.icons.EDIT,
      deleteIcon: enums.icons.DELETE,
      historyIcon: enums.icons.HISTORIC,
      clienteNombre: null,
      razonSocial: "",
      itemVersion: {},
      modalNewVersion: false,
      openActualizacionModal: false,
      actualizacionVersionItem: {},
      observaciones: null,
      sitiosSistema: [],
      camposEditados: [],
      equiposSoporte: [],
      equipoSoporteSelected: null,
      provincias: [],
      provinciaSelected: null,
      sinSoporte: false,
      canCreateVersion: true,
      isLoadingVersion: false,
      isLoadingNotas: false,
      isLoadingProductos: false,
      isSavingPermiteVersionesNoValidadas: false,
      licenciaPerpetua: false,
      estado: null,
      soloActivosConexiones: true,
      soloActivosDatosAcceso: true,
      todosDatosAcceso: true,
      todosConexiones: true,
      calendarIcon: "mdi-calendar",
      fechaLicencia: null,
      fechaLicenciaSelected: null,
      menuFechaLicencia: false,
      fechaBajaSelected: null,
      menuFechaBaja: false,
      fechaBaja: null,
      titleDelete: "",
      isLoading: false,
      tabOptions: { tabId: 1, tabName: "DATOS GENERALES" },
      codigoEquipo: null,
      idVersionToDelete: null,
      idNotaToDelete: null,
      soporte: false,
      permiteVersionesNoValidadas: false,
      rutaDescargaPaquetes: "",
      itemsSitios: [],
      searchSitios: "",
      sistemaSitiosSelected: null,
      expandedSitios: [],
      visibleCadenaConexionSitios: [],
      siteEditorDialog: false,
      isSavingSitio: false,
      showSiteEditorCadenaConexion: false,
      siteEditorValid: false,
      siteEditorIndex: null,
      siteEditorItem: this.createEmptySitio(),
      itemsSistemas: [],
      sistemaSelected: null,
      notaItemToEdit: null,
      itemsNotas: [],
      itemsProductos: [],
      productosContratadosOptions: enums.productosContratados,
      productosOriginalSnapshot: "[]",
      headerNotas: [
        {
          text: "Fecha",
          sortable: false,
          value: "fecha",
        },
        {
          text: "Tipo de nota",
          sortable: false,
          value: "tipoNota",
        },
        {
          text: "Título",
          sortable: false,
          value: "titulo",
        },
        {
          text: "Descripción",
          sortable: false,
          value: "descripcion",
        },
        {
          text: "Usuario",
          sortable: false,
          value: "usuario",
        },
        { text: "Acciones", value: "actions", sortable: false, align: "end" },
      ],
      headersProductos: [
        {
          text: "Producto",
          sortable: false,
          value: "codigo",
          class: "col-producto-codigo",
          cellClass: "col-producto-codigo",
        },
        {
          text: "GUID",
          sortable: false,
          value: "guid",
          class: "col-producto-guid",
          cellClass: "col-producto-guid",
        },
        {
          text: "Activo",
          sortable: false,
          value: "implementado",
          align: "center",
          class: "col-producto-activo",
          cellClass: "col-producto-activo",
        },
        {
          text: "Ubic. ID",
          sortable: false,
          value: "ubic_id",
          align: "center",
          class: "col-producto-ubicacion",
          cellClass: "col-producto-ubicacion",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "end",
          class: "col-producto-acciones",
          cellClass: "col-producto-acciones",
        },
      ],
      headersVersiones: [
        {
          text: "Fecha actualización",
          sortable: false,
          value: "fechaActualizacion",
        },
        { text: "Sistema", sortable: false, value: "sistema" },
        { text: "Versión", sortable: false, value: "versionNombre" },
        { text: "Fecha versión", sortable: false, value: "fechaVersion" },
        { text: "Usuario", sortable: false, value: "usuario" },
        { text: "Acciones", value: "actions", sortable: false, align: "end" },
      ],
      itemsVersiones: [],
      loadingVersiones: false,
      itemsUsuariosAvanzados: [],
      headersUsuariosAvanzados: [
        { text: "Nombre", sortable: false, value: "tipoId.value" },
        {
          text: "Detalle",
          align: "start",
          sortable: false,
          value: "credencial",
        },
        { text: "Acciones", value: "actions", sortable: false, align: "end" },
      ],
      itemsUsuariosBasicos: [],
      itemsContacto: [],
      headersContacto: [
        {
          text: "Nombre",
          sortable: false,
          value: "contactoNombre",
        },
        {
          text: "Referente",
          sortable: false,
          align: "center",
          value: "esReferente",
        },
        {
          text: "Informar actualización",
          sortable: false,
          align: "center",
          value: "informarActualizacion",
        },
        {
          text: "Email",
          sortable: false,
          value: "email",
        },
        {
          text: "Teléfono",
          sortable: false,
          value: "telefono",
        },
        { text: "Acciones", value: "actions", sortable: false, align: "end" },
      ],
      headersUsuariosBasicos: [
        { text: "Nombre", sortable: false, value: "tipoId.value" },
        {
          text: "Detalle",
          align: "start",
          sortable: false,
          value: "credencial",
        },
        { text: "Acciones", value: "actions", sortable: false, align: "end" },
      ],
      headersSitios: [
        {
          text: "Sitio / Sistema",
          sortable: false,
          value: "sistemaNombre",
          align: "start",
        },
        { text: "Descripción", sortable: false, value: "descripcion" },
        {
          text: "Habilitado",
          sortable: false,
          value: "habilitado",
          align: "center",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "end",
          order: 12,
        },
      ],
      itemsServidores: [],
      expandedServidores: [],
      headersServidores: [
        {
          text: "Tipo de servidor",
          sortable: false,
          value: "servidorNombre",
          align: "left",
          class: "col-tipo-servidor",
          width: "180px",
        },
        {
          text: "Descripción",
          sortable: false,
          value: "descripcion",
          align: "left",
        },
        {
          text: "IP",
          sortable: false,
          value: "servidorIp",
          align: "left",
          width: "160px",
        },
        {
          text: "Eliminar",
          value: "delete",
          sortable: false,
          class: "col-eliminar-servidor",
          align: "end",
        },
        {
          text: "",
          value: "data-table-expand",
          align: "center",
        },
      ],
      itemsDatosAcceso: [],
      headersDatosAcceso: [
        {
          text: "Descripción",
          sortable: false,
          value: "datosTexto",
          align: "left",
        },
        {
          text: "Activo",
          sortable: false,
          value: "habilitado",
          align: "end",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "end",
          order: 12,
        },
      ],
      itemsConexiones: [],
      headersConexiones: [
        {
          text: "Conexión",
          sortable: false,
          value: "nombreConexion",
          align: "left",
        },
        {
          text: "IP o url",
          sortable: false,
          value: "datoIp",
          align: "left",
        },
        {
          text: "Usuario",
          sortable: false,
          value: "usuario",
          align: "left",
        },
        {
          text: "Dominio",
          sortable: false,
          value: "dominio",
          align: "left",
        },
        {
          text: "Puerto",
          sortable: false,
          value: "puerto",
          align: "left",
        },
        {
          text: "Activo",
          align: "end",
          sortable: false,
          value: "habilitado",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "end",
          order: 12,
        },
      ],
      loadingView: true,
      itemDatoAcceso: null,
      openEditDatoAcceso: false,
      itemConexion: {},
      openEditDatoConexion: false,
      openEditContactos: false,
      openNotaCliente: false,
      contactoId: null,
      showDeleteModalDatoAcceso: false,
      idToDeleteDatoAcceso: null,
      isLoadingDatosAcceso: false,
      isLoadingConexiones: false,
      showDeleteModalConexion: false,
      idToDeleteConexion: null,
      isLoadingContactos: false,
      showDeleteModalContacto: false,
      showDeleteModalVersion: false,
      showDeleteModalNotas: false,
      showDiscardProductosChangesModal: false,
      showConfirmSaveProductosDeleteModal: false,
      idToDeleteContacto: null,
      itemsTipoServidores: [],
      tipoUsersBasicos: [],
      tipoUsersAvanzados: [],
      allowedActions: null,
      // Usuarios Basicos
      allowedActionsUsuariosBasicos: null,
      canCreateUsuarioBasico: false,
      canDeleteUsuarioBasico: false,
      canEditUsuarioBasico: false,
      // Usuarios Avanzados
      allowedActionsUsuariosAvanzados: null,
      canCreateUsuarioAvanzado: false,
      canDeleteUsuarioAvanzado: false,
      canEditUsuarioAvanzado: false,
      canSeeUsuarioAvanzado: false,
      // Acceso Datos
      allowedActionsDatosAcceso: null,
      canDeleteDatosAcceso: false,
      canCreateDatosAcceso: false,
      canEditDatosAcceso: false,
      // Gestionar notas
      allowedActionsGestionarNotas: null,
      canDeleteGestionarNotas: false,
      canCreateGestionarNotas: false,
      canEditGestionarNotas: false,
      // Conexiones RDP
      allowedActionsConexionesRDP: null,
      canCreateConexionRDP: false,
      canEditConexionRDP: false,
      canDeleteConexionRDP: false,
      canGestionarContactos: false,
      canViewActualizacionesClientes: false,
    };
  },
  async created() {
    await this.setPermisos();
    await this.setSelects();
    if (this.clienteId != null) await this.setDatosCliente();
    else this.loadingView = false;
  },
  methods: {
    ...mapActions({
      getEquipos: "clientesData/equiposTaxonomy",
      getProvincias: "clientesData/provinciasTaxonomy",
      getAllClientData: "clientesData/getAllClientData",
      getVersionesBySistema: "clientesData/getVersionesBySistema",
      saveCliente: "clientesData/saveCliente",
      sistemasTaxonomy: "clientesData/sistemasTaxonomy",
      getUsers: "clientesData/getUsers",
      saveUsuarios: "clientesData/saveUsuarios",
      setAlert: "user/setAlert",
      deleteAccesoDatos: "clientesData/deleteAccesoDatos",
      deleteConexionAction: "clientesData/deleteConexion",
      deleteContactoCliente: "clientesData/deleteContactoCliente",
      deleteVersionCliente: "versiones/deleteVersionCliente",
      servidoresTaxonomy: "clientesData/servidoresTaxonomy",
      sitiosTaxonomy: "clientesData/sitiosTaxonomy",
      sitiosSistemasTaxonomy: "clientesData/sitiosSistemasTaxonomy",
      getTipoUsuarios: "clientesData/getTipoUsuarios",
      updateDatosConfiguracionCliente:
        "clientesData/updateDatosConfiguracionCliente",
      getNotasPorCliente: "clientesData/getNotasPorCliente",
      deleteNotaPorCliente: "clientesData/deleteNotaPorCliente",
      getProductosContratados: "clientesData/getProductosContratados",
      saveProductosContratados: "clientesData/saveProductosContratados",
      puedeVerActualizacionesClientes:
        "versiones/puedeVerActualizacionesClientes",
    }),
    getProductoDescripcion(codigo) {
      return (
        this.productosContratadosOptions.find((x) => x.codigo === codigo)
          ?.descripcion || codigo
      );
    },
    getProductoContratadoKey(producto) {
      const codigo = producto.codigo?.trim().toUpperCase() || "";
      const ubicacion = this.getProductoUbicId(producto);

      return `${codigo}|${
        ubicacion === null || ubicacion === undefined || ubicacion === ""
          ? "NULL"
          : ubicacion
      }`;
    },
    getProductoContratadoId(producto) {
      return producto.productosContratadosId || producto.ProductosContratadosId;
    },
    getProductoUbicId(producto) {
      const ubicId = producto.ubic_id ?? producto.ubicId ?? producto.UbicId;

      return ubicId === "" || ubicId === undefined ? null : ubicId;
    },
    isProductoUbicacionValida(ubicId) {
      return (
        ubicId === null ||
        ubicId === "" ||
        ubicId === undefined ||
        (Number.isInteger(Number(ubicId)) && Number(ubicId) >= 0 && Number(ubicId) <= 32767)
      );
    },
    mapProductoContratado(producto) {
      const productosContratadosId = this.getProductoContratadoId(producto);
      const ubicId = this.getProductoUbicId(producto);

      return {
        ...producto,
        productoLocalId:
          productosContratadosId || `new-${Math.random().toString(36)}`,
        productosContratadosId,
        codigo: producto.codigo || producto.Codigo || "",
        guid: producto.guid || producto.Guid || "",
        implementado: (producto.implementado ?? producto.Implementado) === true,
        ubic_id: ubicId,
        cliente_id:
          producto.cliente_id ||
          producto.clienteId ||
          producto.ClienteId ||
          this.clienteId,
      };
    },
    getProductosSnapshot() {
      const productos = this.itemsProductos
        .map((producto) => ({
          productosContratadosId: this.getProductoContratadoId(producto) || null,
          codigo: producto.codigo || "",
          guid: `${producto.guid || ""}`.toLowerCase(),
          implementado: producto.implementado === true,
          ubic_id: this.getProductoUbicId(producto),
        }))
        .sort((a, b) => {
          const keyA = `${a.productosContratadosId || ""}|${a.codigo}|${
            a.ubic_id ?? "NULL"
          }|${a.guid}`;
          const keyB = `${b.productosContratadosId || ""}|${b.codigo}|${
            b.ubic_id ?? "NULL"
          }|${b.guid}`;

          return keyA.localeCompare(keyB);
        });

      return JSON.stringify(productos);
    },
    setProductosOriginalSnapshot() {
      this.productosOriginalSnapshot = this.getProductosSnapshot();
    },
    getProductosOriginales() {
      try {
        return JSON.parse(this.productosOriginalSnapshot || "[]");
      } catch {
        return [];
      }
    },
    hasProductosEliminados() {
      const currentIds = new Set(
        this.itemsProductos
          .map((producto) => this.getProductoContratadoId(producto))
          .filter((id) => id)
          .map((id) => `${id}`)
      );

      return this.getProductosOriginales().some(
        (producto) =>
          producto.productosContratadosId &&
          !currentIds.has(`${producto.productosContratadosId}`)
      );
    },
    filterSitios(value, search, item) {
      if (!search) return true;

      const text = [
        item.sistemaNombre,
        item.sitioNombre,
        item.descripcion,
        item.rutaDestino,
        item.carpetaBackup,
        item.nombreSitioIIS,
        item.nombrePoolIIS,
        item.puertoIIS,
        item.cadenaConexion,
        item.habilitado ? "habilitado activo si" : "deshabilitado inactivo no",
      ]
        .filter((x) => x !== null && x !== undefined)
        .join(" ")
        .toString()
        .toLowerCase();

      return text.includes(search.toString().toLowerCase());
    },
    escapeRegExp(value) {
      return value.toString().replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    },
    escapeHtml(value) {
      return value
        .toString()
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    },
    highlightSitioText(value) {
      const text = this.escapeHtml(value ?? "");
      const search = (this.searchSitios || "").toString().trim();

      if (!search) return text;

      const pattern = new RegExp(`(${this.escapeRegExp(search)})`, "gi");
      return text.replace(pattern, '<mark class="sitio-search-hit">$1</mark>');
    },
    getSitioDetailFields(item) {
      return [
        { label: "Ruta destino", value: item.rutaDestino },
        { label: "Carpeta backup", value: item.carpetaBackup },
        { label: "Sitio IIS", value: item.nombreSitioIIS },
        { label: "Pool IIS", value: item.nombrePoolIIS },
        { label: "Puerto IIS", value: item.puertoIIS },
        {
          label: "Cadena conexión",
          value: item.cadenaConexion,
          sensitive: true,
        },
      ].filter(
        (field) =>
          field.value !== null &&
          field.value !== undefined &&
          field.value.toString().trim() !== ""
      );
    },
    getMaskedValue(value) {
      if (!value) return "";
      return "•".repeat(Math.min(value.toString().length, 64));
    },
    getSitioVisibilityKey(item) {
      return item.sitioLocalId || item.sitioSistemaClienteId || item;
    },
    normalizeNullableNumber(value) {
      if (value === null || value === undefined || value === "") return null;

      const numberValue = Number(value);
      return Number.isInteger(numberValue) ? numberValue : null;
    },
    normalizeSitioPayload(item) {
      return {
        ...item,
        puertoIIS: this.normalizeNullableNumber(item.puertoIIS),
      };
    },
    isSitioCadenaVisible(item) {
      return this.visibleCadenaConexionSitios.includes(
        this.getSitioVisibilityKey(item)
      );
    },
    toggleSitioCadenaVisible(item) {
      if (!this.canSeeUsuarioAvanzado) return;

      const key = this.getSitioVisibilityKey(item);

      if (this.visibleCadenaConexionSitios.includes(key)) {
        this.visibleCadenaConexionSitios =
          this.visibleCadenaConexionSitios.filter((x) => x !== key);
        return;
      }

      this.visibleCadenaConexionSitios = [
        ...this.visibleCadenaConexionSitios,
        key,
      ];
    },
    createEmptySitio() {
      return {
        sitioLocalId: `sitio-${Date.now()}-${Math.random().toString(36)}`,
        sitioSistemaClienteId: 0,
        descripcion: "",
        sitioNombre: "",
        sitioSistemaId: null,
        sistemaId: null,
        sistemaNombre: "",
        tipoDespliegueId: null,
        tipoDespliegueCodigo: "",
        tipoDespliegueDescripcion: "",
        rutaDestino: "",
        carpetaBackup: "",
        nombreSitioIIS: "",
        nombrePoolIIS: "",
        puertoIIS: null,
        cadenaConexion: "",
        habilitado: true,
        sistemaToEdit: null,
        sitioToEdit: null,
        itemsSitiosBySistema: [],
      };
    },
    cloneSitio(item) {
      return {
        ...this.createEmptySitio(),
        ...item,
        sitioLocalId:
          item?.sitioLocalId ||
          `sitio-${item?.sitioSistemaClienteId || Date.now()}-${Math.random()
            .toString(36)
            .slice(2)}`,
        sistemaToEdit: item?.sistemaToEdit
          ? { ...item.sistemaToEdit }
          : null,
        sitioToEdit: item?.sitioToEdit ? { ...item.sitioToEdit } : null,
        itemsSitiosBySistema: item?.itemsSitiosBySistema
          ? [...item.itemsSitiosBySistema]
          : [],
      };
    },
    openNewSitioEditor() {
      this.siteEditorIndex = null;
      this.siteEditorItem = this.createEmptySitio();
      this.showSiteEditorCadenaConexion = false;
      this.siteEditorDialog = true;
      this.$nextTick(() => this.$refs.siteForm?.resetValidation());
    },
    openEditSitioEditor(item) {
      const indexById = this.itemsSitios.findIndex(
        (sitio) => sitio.sitioLocalId === item.sitioLocalId
      );
      this.siteEditorIndex =
        indexById >= 0 ? indexById : this.itemsSitios.indexOf(item);
      this.siteEditorItem = this.cloneSitio(item);
      this.setSitiosBySistemaForEditor();
      this.showSiteEditorCadenaConexion = false;
      this.siteEditorDialog = true;
      this.$nextTick(() => this.$refs.siteForm?.resetValidation());
    },
    closeSitioEditor() {
      this.siteEditorDialog = false;
      this.siteEditorIndex = null;
      this.siteEditorItem = this.createEmptySitio();
      this.showSiteEditorCadenaConexion = false;
      this.$nextTick(() => this.$refs.siteForm?.resetValidation());
    },
    async confirmSitioEditor() {
      if (!this.$refs.siteForm?.validate()) return;

      const sitio = this.normalizeSitioEditorItem(this.siteEditorItem);
      let sitios;

      if (this.siteEditorIndex === null || this.siteEditorIndex < 0) {
        sitios = [sitio, ...this.itemsSitios];
      } else {
        sitios = [...this.itemsSitios];
        sitios.splice(this.siteEditorIndex, 1, sitio);
      }

      if (!this.clienteId) {
        this.itemsSitios = sitios;
        this.markDatosSitiosChanged();
        this.closeSitioEditor();
        return;
      }

      this.isSavingSitio = true;
      try {
        const sitiosPayload = sitios.map((item) =>
          this.normalizeSitioPayload(item)
        );
        const response = await this.updateDatosConfiguracionCliente({
          clienteId: this.clienteId,
          listaServidores: null,
          listaSitios: sitiosPayload,
          listaUsuarios: null,
          rutaDescargaPaquetes: this.rutaDescargaPaquetes || "",
        });

        if (response.status === 200) {
          this.itemsSitios = sitios;
          this.camposEditados = this.camposEditados.filter(
            (campo) => campo !== "datosSitios"
          );
          this.setAlert({
            type: "success",
            message: "Sitio guardado con éxito.",
          });
          this.closeSitioEditor();
          await this.refreshSitiosCliente();
        }
      } catch (error) {
        console.error(error);
      }
      this.isSavingSitio = false;
    },
    removeSitio(item) {
      const key = this.getSitioVisibilityKey(item);
      this.itemsSitios = this.itemsSitios.filter((x) => x !== item);
      this.expandedSitios = this.expandedSitios.filter((x) => x !== item);
      this.visibleCadenaConexionSitios =
        this.visibleCadenaConexionSitios.filter((x) => x !== key);
      this.markDatosSitiosChanged();
    },
    toggleSitioExpanded(item) {
      if (this.expandedSitios.includes(item)) {
        this.expandedSitios = this.expandedSitios.filter((x) => x !== item);
        this.visibleCadenaConexionSitios =
          this.visibleCadenaConexionSitios.filter(
            (x) => x !== this.getSitioVisibilityKey(item)
          );
        return;
      }

      this.expandedSitios = [item];
    },
    getSitioRowClass(item) {
      return this.expandedSitios.includes(item) ? "sitio-row-expanded" : "";
    },
    markDatosSitiosChanged() {
      if (!this.camposEditados.includes("datosSitios"))
        this.camposEditados.push("datosSitios");
    },
    setSitiosBySistemaForEditor() {
      if (!this.siteEditorItem.sistemaToEdit) {
        this.siteEditorItem.itemsSitiosBySistema = [];
        return;
      }

      this.siteEditorItem.itemsSitiosBySistema = this.sitiosSistema.filter(
        (x) => x.sistema == this.siteEditorItem.sistemaToEdit.id
      );
    },
    onSiteEditorSistemaChange() {
      const sistema = this.siteEditorItem.sistemaToEdit;
      this.siteEditorItem.sistemaId = sistema?.id || null;
      this.siteEditorItem.sistemaNombre = sistema?.value || "";
      this.siteEditorItem.sitioToEdit = null;
      this.siteEditorItem.sitioSistemaId = null;
      this.siteEditorItem.sitioNombre = "";
      this.siteEditorItem.tipoDespliegueId = null;
      this.siteEditorItem.tipoDespliegueCodigo = "";
      this.siteEditorItem.tipoDespliegueDescripcion = "";
      this.setSitiosBySistemaForEditor();
    },
    onSiteEditorSitioChange() {
      const sitio = this.siteEditorItem.sitioToEdit;
      this.siteEditorItem.sitioSistemaId = sitio?.id || null;
      this.siteEditorItem.sitioNombre = sitio?.value || "";
      this.siteEditorItem.tipoDespliegueId = sitio?.tipoDespliegueId || null;
      this.siteEditorItem.tipoDespliegueCodigo =
        sitio?.tipoDespliegueCodigo || "";
      this.siteEditorItem.tipoDespliegueDescripcion =
        sitio?.tipoDespliegueDescripcion || "";
    },
    normalizeSitioEditorItem(item) {
      const sitio = this.cloneSitio(item);
      const sistema = sitio.sistemaToEdit;
      const sitioTaxonomy = sitio.sitioToEdit;

      sitio.sistemaId = sistema?.id || null;
      sitio.sistemaNombre = sistema?.value || "";
      sitio.sitioSistemaId = sitioTaxonomy?.id || null;
      sitio.sitioNombre = sitioTaxonomy?.value || "";
      sitio.tipoDespliegueId =
        sitioTaxonomy?.tipoDespliegueId || sitio.tipoDespliegueId || null;
      sitio.tipoDespliegueCodigo =
        sitioTaxonomy?.tipoDespliegueCodigo || sitio.tipoDespliegueCodigo || "";
      sitio.tipoDespliegueDescripcion =
        sitioTaxonomy?.tipoDespliegueDescripcion ||
        sitio.tipoDespliegueDescripcion ||
        "";
      sitio.descripcion = sitio.descripcion?.trim() || "";
      sitio.habilitado = sitio.habilitado !== false;
      sitio.puertoIIS = this.normalizeNullableNumber(sitio.puertoIIS);

      return sitio;
    },
    getTipoDespliegueLabel(item) {
      return (
        item?.sitioToEdit?.tipoDespliegueDescripcion ||
        item?.tipoDespliegueDescripcion ||
        this.getTipoDespliegueCodigo(item) ||
        "Sin tipo"
      );
    },
    getTipoDespliegueCodigo(item) {
      const sitioSistemaId = item?.sitioToEdit?.id || item?.sitioSistemaId;
      const sitioCatalogo = this.sitiosSistema.find(
        (sitio) => sitio.id === sitioSistemaId
      );

      return (
        item?.sitioToEdit?.tipoDespliegueCodigo ||
        item?.tipoDespliegueCodigo ||
        sitioCatalogo?.tipoDespliegueCodigo ||
        ""
      )
        .trim()
        .toUpperCase();
    },
    isSitioSql(item) {
      const tipoDespliegueCodigo = this.getTipoDespliegueCodigo(item);
      if (tipoDespliegueCodigo)
        return tipoDespliegueCodigo === "SQL_SCRIPTS";

      const sitioNombre = item?.sitioToEdit?.value || item?.sitioNombre || "";
      return sitioNombre.trim().toUpperCase().includes("SQL");
    },
    isSitioIis(item) {
      const tipoDespliegueCodigo = this.getTipoDespliegueCodigo(item);
      return (
        tipoDespliegueCodigo === "IIS_SITE" ||
        (!tipoDespliegueCodigo && !this.isSitioSql(item))
      );
    },
    isSitioApplication(item) {
      const tipoDespliegueCodigo = this.getTipoDespliegueCodigo(item);
      return (
        ["IIS_SITE", "DESKTOP_FILES"].includes(tipoDespliegueCodigo) ||
        (!tipoDespliegueCodigo && !this.isSitioSql(item))
      );
    },
    onSitioSelected(item) {
      const sitio = item.sitioToEdit;
      if (!sitio) return;

      item.sitioSistemaId = sitio.id;
      item.sitioNombre = sitio.value;
      item.tipoDespliegueId = sitio.tipoDespliegueId;
      item.tipoDespliegueCodigo = sitio.tipoDespliegueCodigo || "";
      item.tipoDespliegueDescripcion = sitio.tipoDespliegueDescripcion || "";

      if (this.isSitioSql(item)) {
        item.rutaDestino = "";
        item.carpetaBackup = "";
        item.nombreSitioIIS = "";
        item.nombrePoolIIS = "";
        item.puertoIIS = null;
      } else {
        item.cadenaConexion = "";
        if (!this.isSitioIis(item)) {
          item.nombreSitioIIS = "";
          item.nombrePoolIIS = "";
          item.puertoIIS = null;
        }
      }

      if (!this.camposEditados.includes("datosSitios"))
        this.camposEditados.push("datosSitios");
    },
    async setPermisos() {
      if (this.permisos.canAccesoDatos) await this.setPermisosAccesoDatos();
      if (this.permisos.canAccesoGestionarNotas)
        await this.setPermisosGestionarNotas();
      if (this.permisos.canConexionRdp) await this.setPermisosConexionRdp();
      if (this.permisos.canAccesoBasicos)
        await this.setPermisosUsuariosBasicos();
      if (this.permisos.canAccesoAvanzados)
        await this.setPermisosUsuariosAvanzados();
      if (this.permisos.canGestionarContactos)
        this.canGestionarContactos = true;
    },
    async setPermisosUsuariosAvanzados() {
      await this.$store.dispatch(
        "user/updateFrequencyByOptionCode",
        enumsAdmin.adminSistema.permissions.USUARIOS_AVANZADOS
      );
      this.allowedActionsUsuariosAvanzados = JSON.parse(
        localStorage.getItem("allowedActions")
      );
      this.allowedActionsUsuariosAvanzados?.forEach((x) => {
        switch (x.optionCode) {
          case enumsAdmin.adminSistema.permissions.DELETE_USER_AVANZADO:
            this.canDeleteUsuarioAvanzado = true;
            break;
          case enumsAdmin.adminSistema.permissions.EDIT_USER_AVANZADO:
            this.canEditUsuarioAvanzado = true;
            break;
          case enumsAdmin.adminSistema.permissions.NUEVO_USER_AVANZADO:
            this.canCreateUsuarioAvanzado = true;
            break;
          case enumsAdmin.adminSistema.permissions.VER_USER_AVANZADO:
            this.canSeeUsuarioAvanzado = true;
            break;
          default:
            break;
        }
      });
    },
    async setPermisosUsuariosBasicos() {
      await this.$store.dispatch(
        "user/updateFrequencyByOptionCode",
        enumsAdmin.adminSistema.permissions.USUARIOS_BASICOS
      );
      this.allowedActionsUsuariosBasicos = JSON.parse(
        localStorage.getItem("allowedActions")
      );
      this.allowedActionsUsuariosBasicos?.forEach((x) => {
        switch (x.optionCode) {
          case enumsAdmin.adminSistema.permissions.DELETE_USER_BASICO:
            this.canDeleteUsuarioBasico = true;
            break;
          case enumsAdmin.adminSistema.permissions.EDIT_USER_BASICO:
            this.canEditUsuarioBasico = true;
            break;
          case enumsAdmin.adminSistema.permissions.NUEVO_USER_BASICO:
            this.canCreateUsuarioBasico = true;
            break;
          default:
            break;
        }
      });
    },
    async setPermisosGestionarNotas() {
      await this.$store.dispatch(
        "user/updateFrequencyByOptionCode",
        webSiteOptions.GESTIONAR_NOTAS
      );
      this.allowedActionsGestionarNotas = JSON.parse(
        localStorage.getItem("allowedActions")
      );
      this.allowedActionsGestionarNotas?.forEach((x) => {
        switch (x.optionCode) {
          case enumsAdmin.adminSistema.permissions.DELETE_NOTA:
            this.canDeleteGestionarNotas = true;
            break;
          case enumsAdmin.adminSistema.permissions.EDIT_NOTA:
            this.canEditGestionarNotas = true;
            break;
          case enumsAdmin.adminSistema.permissions.NUEVA_NOTA:
            this.canCreateGestionarNotas = true;
            break;
          default:
            break;
        }
      });
    },
    async setPermisosAccesoDatos() {
      await this.$store.dispatch(
        "user/updateFrequencyByOptionCode",
        webSiteOptions.DATOS_ACCESO
      );
      this.allowedActionsDatosAcceso = JSON.parse(
        localStorage.getItem("allowedActions")
      );
      this.allowedActionsDatosAcceso?.forEach((x) => {
        switch (x.optionCode) {
          case enumsAdmin.adminSistema.permissions.DELETE_DATOS_ACCESO:
            this.canDeleteDatosAcceso = true;
            break;
          case enumsAdmin.adminSistema.permissions.EDIT_DATOS_ACCESO:
            this.canEditDatosAcceso = true;
            break;
          case enumsAdmin.adminSistema.permissions.NUEVO_DATO_ACCESO:
            this.canCreateDatosAcceso = true;
            break;
          default:
            break;
        }
      });
    },
    async setPermisosConexionRdp() {
      await this.$store.dispatch(
        "user/updateFrequencyByOptionCode",
        webSiteOptions.CONEXIONES_RDP
      );
      this.allowedActionsConexionesRDP = JSON.parse(
        localStorage.getItem("allowedActions")
      );
      this.allowedActionsConexionesRDP?.forEach((x) => {
        switch (x.optionCode) {
          case enumsAdmin.adminSistema.permissions.DELETE_CONEXION_RDP:
            this.canDeleteConexionRDP = true;
            break;
          case enumsAdmin.adminSistema.permissions.EDIT_CONEXION_RDP:
            this.canEditConexionRDP = true;
            break;
          case enumsAdmin.adminSistema.permissions.NUEVA_CONEXION_RDP:
            this.canCreateConexionRDP = true;
            break;
          default:
            break;
        }
      });
    },
    async switchTab(num) {
      switch (num) {
        case 1:
          this.tabOptions.tabName = "DATOS GENERALES";
          this.tabOptions.tabId = 1;
          break;
        case 2:
          this.tabOptions.tabName = "CONEXIÓN";
          this.tabOptions.tabId = 2;
          break;
        case 3:
          this.tabOptions.tabName = "CONFIGURACIÓN";
          this.tabOptions.tabId = 3;
          break;
        case 4:
          this.tabOptions.tabName = "CONTACTOS";
          this.tabOptions.tabId = 4;
          break;
        case 5:
          this.tabOptions.tabName = "VERSIONES";
          this.tabOptions.tabId = 5;
          break;
        case 6:
          this.tabOptions.tabName = "NOTAS";
          this.tabOptions.tabId = 6;
          break;
        case 7:
          this.tabOptions.tabName = "PRODUCTOS";
          this.tabOptions.tabId = 7;
          break;
      }
    },
    async getVersiones() {
      this.loadingVersiones = true;
      const params = {
        clienteId: this.clienteId,
        sistemaId: this.sistemaSelected == null ? 0 : this.sistemaSelected.id,
      };
      try {
        const res = await this.getVersionesBySistema(params);
        this.itemsVersiones = res;
      } catch (error) {
        console.error(error);
      }
      this.loadingVersiones = false;
    },
    setItemsSitios(sitios = []) {
      this.itemsSitios = sitios;
      this.itemsSitios.map((el) => {
        el.sitioLocalId =
          el.sitioLocalId ||
          `sitio-${el.sitioSistemaClienteId || Date.now()}-${Math.random()
            .toString(36)
            .slice(2)}`;
        if (el.habilitado === null || el.habilitado === undefined)
          el.habilitado = true;
        el.itemsSitiosBySistema = this.sitiosSistema.filter(
          (x) => x.sistema == el.sistemaId
        );
      });
    },
    async refreshSitiosCliente() {
      const res = await this.getAllClientData(this.clienteId);
      this.setItemsSitios(res.infoSitios);
    },
    async setDatosCliente() {
      this.formEditTitle = "Editar cliente";
      this.loadingVersiones = true;
      try {
        const res = await this.getAllClientData(this.clienteId);
        this.provinciaSelected = res.provId
          ? this.provincias.find((x) => x.id === res.provId)?.id
          : null;
        this.setItemsSitios(res.infoSitios);
        this.codigoEquipo = res.codigoEquipo;
        this.clienteNombre = res.clienteNombre;
        this.observaciones = res.observaciones;
        this.licenciaPerpetua = res.licenciaPerpetua;
        this.fechaLicencia = res.fechaLicencia;
        this.razonSocial = res.razonSocial;
        this.soporte = res.soporte;
        this.itemsServidores = res.servidores;
        this.itemsConexiones = res.conexiones;
        this.obvservaciones = res.obvservaciones;
        this.itemsVersiones = res.version;
        this.itemsContacto = res.contacto;
        this.itemsDatosAcceso = res.datosAcceso;
        this.itemsNotas = res.notas;
        await this.loadProductos();
        this.sinSoporte = res.sinSoporte;
        this.permiteVersionesNoValidadas =
          res.permiteVersionesNoValidadas === true;
        this.rutaDescargaPaquetes = res.rutaDescargaPaquetes || "";
        this.licenciaPerpetua = res.licenciaPerpetua;
        this.equipoSoporteSelected = res.codigoEquipo;
        this.fechaLicencia = this.parseDateToIso(res.fechaLicenciaToShow);
        this.fechaLicenciaSelected = this.formatDate(this.fechaLicencia);
        if (res.fechaBaja != null) {
          this.fechaBaja = this.parseDateToIso(res.fechaBaja);
          this.fechaBajaSelected = this.formatDate(this.fechaBaja);
        } else {
          this.fechaBaja = null;
          this.fechaBajaSelected = null;
        }
        this.getEstadoCliente();
      } catch (error) {
        console.error(error);
      }
      this.loadingVersiones = false;
      this.loadingView = false;
      this.isLoadingDatosAcceso = false;
      this.isLoadingConexiones = false;
      this.isLoadingContactos = false;
      this.isLoadingProductos = false;
    },
    getEstadoCliente() {
      if (this.fechaBaja != null) this.estado = "Estado: De baja";
      else {
        if (this.sinSoporte) this.estado = "Estado: Sin soporte";
        else this.estado = "Estado: Activo";
      }
    },
    async loadProductos() {
      if (!this.clienteId) return;

      this.isLoadingProductos = true;
      try {
        const productos = await this.getProductosContratados(this.clienteId);
        this.itemsProductos = productos.map((x) =>
          this.mapProductoContratado(x)
        );
        this.setProductosOriginalSnapshot();
      } catch (error) {
        console.error(error);
      }
      this.isLoadingProductos = false;
    },
    addProducto() {
      this.itemsProductos.push({
        productoLocalId: `new-${Date.now()}-${Math.random().toString(36)}`,
        productosContratadosId: null,
        codigo: "",
        guid: "",
        implementado: false,
        ubic_id: null,
        cliente_id: this.clienteId,
      });
    },
    removeProducto(item) {
      this.itemsProductos = this.itemsProductos.filter(
        (x) => x.productoLocalId !== item.productoLocalId
      );
    },
    getEstadoColor(estado) {
      switch (estado) {
        case "Estado: Activo":
          return "green";
        case "Estado: Sin soporte":
          return "orange";
        case "Estado: De baja":
          return "red";
        default:
          return "grey";
      }
    },
    editNota(item) {
      this.notaItemToEdit = item;
      this.openNotaCliente = true;
    },
    editContacto(item) {
      if (item) this.contactoId = item.contactoId;
      else this.contactoId = null;

      this.openEditContactos = true;
    },
    editConexion(item) {
      if (item) this.itemConexion = item;
      else this.itemConexion = null;

      this.openEditDatoConexion = true;
    },
    addDatoAcceso(item) {
      if (item) this.itemDatoAcceso = item;
      else this.itemDatoAcceso = null;

      this.openEditDatoAcceso = true;
    },
    deleteDatosAcceso(item) {
      this.titleDelete =
        "¿Desea eliminar el dato de acceso de la base de datos?";
      this.showDeleteModalDatoAcceso = true;
      this.idToDeleteDatoAcceso = item.idDatos;
    },
    async confirmDeleteDatosAcceso() {
      this.isLoadingDatosAcceso = true;
      try {
        const response = await this.deleteAccesoDatos(
          this.idToDeleteDatoAcceso
        );
        if (response.status === 200) {
          this.showDeleteModalDatoAcceso = false;
          this.setAlert({ type: "success", message: "Eliminado con éxito." });
          await this.setDatosCliente();
        }
      } catch (error) {
        console.error(error);
      }
    },
    deleteConexion(item) {
      this.titleDelete = "¿Desea eliminar la conexión de la base de datos?";
      this.showDeleteModalConexion = true;
      this.idToDeleteConexion = item.id;
    },
    async confirmDeleteConexion() {
      this.isLoadingConexiones = true;
      const response = await this.deleteConexionAction(this.idToDeleteConexion);
      if (response.status === 200) {
        this.showDeleteModalConexion = false;
        this.setAlert({ type: "success", message: "Eliminado con éxito." });
        await this.setDatosCliente();
      }
    },
    openModalDeleteNota(item) {
      this.titleDelete = "¿Desea eliminar nota del cliente?";
      this.idNotaToDelete = item.notaId;
      this.showDeleteModalNotas = true;
    },
    async confirmDeleteNota() {
      this.isLoadingNotas = true;
      try {
        const response = await this.deleteNotaPorCliente(this.idNotaToDelete);
        if (response) {
          this.setAlert({ type: "success", message: "Eliminado con éxito." });
          const notasItems = await this.getNotasPorCliente(this.clienteId);
          this.itemsNotas = notasItems;
          this.showDeleteModalNotas = false;
        }
      } catch (error) {
        console.error(error);
      }
      this.isLoadingNotas = false;
    },
    deleteContacto(item) {
      this.titleDelete = "¿Desea eliminar el contacto de la base de datos?";
      this.showDeleteModalContacto = true;
      this.idToDeleteContacto = item.contactoId;
    },
    openModalDeleteVersion(id) {
      this.titleDelete = "¿Desea eliminar la versión?";
      this.idVersionToDelete = id;
      this.showDeleteModalVersion = true;
    },
    async confirmDeleteContacto() {
      this.isLoadingContactos = true;
      try {
        const response = await this.deleteContactoCliente(
          this.idToDeleteContacto
        );
        if (response.status === 200) {
          this.showDeleteModalContacto = false;
          this.setAlert({ type: "success", message: "Eliminado con éxito." });
          await this.setDatosCliente();
        }
      } catch (error) {
        console.error(error);
      }
      this.isLoadingDelete = false;
    },
    async confirmDeleteVersion() {
      this.isLoadingVersion = true;
      try {
        const response = await this.deleteVersionCliente(
          this.idVersionToDelete
        );
        if (response) {
          this.showDeleteModalVersion = false;
          this.setAlert({ type: "success", message: "Eliminado con éxito." });
          await this.getVersiones();
        }
      } catch (error) {
        console.error(error);
      }
      this.isLoadingVersion = false;
    },
    async setSelects() {
      this.equiposSoporte = await this.getEquipos();
      this.provincias = await this.getProvincias();
      const sistemas = await this.sistemasTaxonomy();
      this.itemsSistemas = sistemas;
      const servidores = await this.servidoresTaxonomy();
      this.itemsTipoServidores = servidores;
      const sitios = await this.sitiosSistemasTaxonomy();
      this.sitiosSistema = sitios;
      this.canViewActualizacionesClientes =
        await this.puedeVerActualizacionesClientes();
      this.setSelectAvanzados();
      this.setSelectBasicos();
      if (this.clienteId) await this.loadUsuarios();
    },
    async setSelectAvanzados() {
      const tipoUserAvanzado = await this.getTipoUsuarios();
      this.tipoUsersAvanzados = tipoUserAvanzado.filter(
        (x) => x.bool === false
      );
    },
    async setSelectBasicos() {
      const tipoUserBasico = await this.getTipoUsuarios();
      this.tipoUsersBasicos = tipoUserBasico.filter((x) => x.bool === true);
    },
    getSitiosBySistemaSelected(item) {
      item.itemsSitiosBySistema = this.sitiosSistema.filter(
        (x) => x.sistema == item.sistemaToEdit.id
      );
    },
    async loadUsuarios() {
      const response = await this.getUsers(this.clienteId);
      this.itemsUsuariosAvanzados = response.usuariosAvanzados;
      this.itemsUsuariosBasicos = response.usuariosBasicos;
    },
    async saveDatosCliente() {
      this.loadingView = true;
      if (this.tabOptions.tabId == 3) {
        const shouldReloadUsuarios = this.camposEditados.includes(
          "datosUsuarios"
        );
        const data = {
          clienteId: this.clienteId,
          listaServidores: this.camposEditados.includes("datosServidores")
            ? this.itemsServidores
            : null,
          listaSitios: this.camposEditados.includes("datosSitios")
            ? this.itemsSitios.map((item) => this.normalizeSitioPayload(item))
            : null,
          listaUsuarios: this.camposEditados.includes("datosUsuarios")
            ? this.itemsUsuariosAvanzados.concat(this.itemsUsuariosBasicos)
            : null,
          rutaDescargaPaquetes: this.rutaDescargaPaquetes || "",
        };
        const response = await this.updateDatosConfiguracionCliente(data);
        try {
          if (response.status === 200) {
            this.showDeleteModalContacto = false;
            this.setAlert({
              type: "success",
              message: "Datos actualizados con éxito.",
            });
            this.camposEditados = [];
            await this.setDatosCliente();
            if (shouldReloadUsuarios) await this.loadUsuarios();
          }
        } catch {
          console.error();
        }
      }
      if (this.tabOptions.tabId == 1) {
        const data = {
          clienteId: !this.clienteId ? -1 : this.clienteId,
          clienteNombre: this.clienteNombre,
          provId: this.provinciaSelected,
          soporte: this.soporte,
          sinSoporte: this.sinSoporte,
          razonSocial: this.razonSocial,
          licenciaPerpetua: this.licenciaPerpetua,
          fechaLicencia: this.parseDateToIso(this.fechaLicenciaSelected),
          fechaBaja: this.parseDateToIso(this.fechaBajaSelected),
          observaciones: this.observaciones,
          equipoId: this.equipoSoporteSelected,
        };
        const response = await this.saveCliente(data);
        try {
          if (response.status === 200) {
            this.clienteId = response.data.data;
            this.setAlert({
              type: "success",
              message: "Datos guardados con éxito.",
            });
            await this.setDatosCliente();
          }
        } catch {
          console.error();
        }
      }
      if (this.tabOptions.tabId == 7) {
        if (this.hasProductosDuplicados) {
          this.setAlert({
            type: "error",
            message:
              "No se puede repetir el mismo producto para la misma ubicación.",
          });
          this.loadingView = false;
          return;
        }

        if (this.hasProductosEliminados()) {
          this.titleDelete = "¿Desea guardar eliminando productos?";
          this.showConfirmSaveProductosDeleteModal = true;
          this.loadingView = false;
          return;
        }

        await this.saveProductosContratadosCliente();
      }
      this.loadingView = false;
    },
    async saveProductosContratadosCliente() {
      if (this.hasProductosDuplicados) {
        this.setAlert({
          type: "error",
          message:
            "No se puede repetir el mismo producto para la misma ubicación.",
        });
        return;
      }

      this.isLoadingProductos = true;
      const productos = this.itemsProductos.map((x) => ({
        productosContratadosId: this.getProductoContratadoId(x),
        codigo: x.codigo,
        guid: x.guid,
        implementado: x.implementado,
        ubic_id: this.getProductoUbicId(x),
        cliente_id: this.clienteId,
      }));

      try {
        const response = await this.saveProductosContratados({
          clienteId: this.clienteId,
          productos,
        });
        if (response.status === 200) {
          this.setAlert({
            type: "success",
            message: "Productos actualizados con éxito.",
          });
          await this.loadProductos();
          this.setProductosOriginalSnapshot();
        }
      } catch (error) {
        console.error(error);
      }
      this.isLoadingProductos = false;
    },
    async confirmSaveProductosConEliminados() {
      this.showConfirmSaveProductosDeleteModal = false;
      this.loadingView = true;
      await this.saveProductosContratadosCliente();
      this.loadingView = false;
    },
    async savePermiteVersionesNoValidadas() {
      this.isSavingPermiteVersionesNoValidadas = true;
      const data = {
        clienteId: this.clienteId,
        permiteVersionesNoValidadas: this.permiteVersionesNoValidadas,
      };
      try {
        const response = await this.updateDatosConfiguracionCliente(data);
        if (response.status === 200) {
          this.setAlert({
            type: "success",
            message: "Configuracion de versiones actualizada con exito.",
          });
        }
      } catch (error) {
        this.permiteVersionesNoValidadas =
          !this.permiteVersionesNoValidadas;
        console.error(error);
      } finally {
        this.isSavingPermiteVersionesNoValidadas = false;
      }
    },
    async closeAndReloadDatosAcceso(reload) {
      if (reload) this.isLoadingDatosAcceso = true;
      this.openEditDatoAcceso = false;
      await this.setDatosCliente();
    },
    async closeAndReloadConexiones(reload) {
      if (reload) this.isLoadingConexiones = true;
      this.openEditDatoConexion = false;
      await this.setDatosCliente();
    },
    async closeAndReloadNotas() {
      this.openNotaCliente = false;
      this.notaItemToEdit = null;
      const notasItems = await this.getNotasPorCliente(this.clienteId);
      this.itemsNotas = notasItems;
    },
    closeAndReloadVersiones() {
      this.modalNewVersion = false;
      this.getVersiones();
    },
    async closeAndReloadContactos(reload) {
      if (reload) this.isLoadingContactos = true;
      this.openEditContactos = false;
      await this.setDatosCliente();
    },
    openModalNewVersion(item) {
      this.modalNewVersion = true;
      this.itemVersion = item;
    },
    openActualizacionVersion(item) {
      this.actualizacionVersionItem = {
        clienteId: item.clienteId || this.clienteId,
        versionId: item.versionId,
      };
      this.openActualizacionModal = true;
    },
    closeModal() {
      if (this.hasUnsavedChanges) {
        this.titleDelete = "¿Desea salir sin guardar los cambios?";
        this.showDiscardProductosChangesModal = true;
        return;
      }

      this.$emit("closeAndReload", false);
    },
    confirmCloseWithoutSaving() {
      this.showDiscardProductosChangesModal = false;
      this.$emit("closeAndReload", false);
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDateToIso(date) {
      if (!date) return null;
      if (date.length === 10) {
        const [day, month, year] = date.split("/");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      }
    },
  },
};
</script>

<style>
.center-input >>> input {
  text-align: center;
}
.col-tipo-servidor {
  width: 160px !important;
  max-width: 160px !important;
  min-width: 140px !important;
}
.col-eliminar-servidor {
  width: 78px !important;
  max-width: 78px !important;
  min-width: 78px !important;
}
.col-producto-codigo {
  width: 28% !important;
}
.col-producto-guid {
  width: 42% !important;
  min-width: 430px !important;
}
.col-producto-activo {
  width: 120px !important;
  min-width: 120px !important;
}
.col-producto-ubicacion {
  width: 100px !important;
  min-width: 100px !important;
}
.producto-ubicacion-input input {
  text-align: center;
}
.col-producto-acciones {
  width: 90px !important;
  min-width: 90px !important;
}
.producto-guid-cell .v-input {
  width: 100%;
  min-width: 430px;
}
.producto-switch-cell {
  display: flex;
  align-items: center;
  justify-content: center;
}
.producto-switch-cell .v-input {
  flex: 0 0 auto;
}
.sitios-web-table .v-data-table__wrapper {
  overflow-x: auto;
}
.sitios-web-table tbody tr {
  cursor: pointer;
}
.sitios-web-table tbody tr.sitio-row-expanded {
  background-color: #eef7fb;
  box-shadow: inset 3px 0 0 #0f5a78;
}
.sitios-web-table tbody tr.sitio-row-expanded + tr {
  background-color: #fff;
}
.sitios-table-toolbar {
  padding: 14px 16px 8px 16px;
}
.sitios-table-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
}
.sitios-filters {
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 10px;
}
.sitios-search {
  flex: 1 1 260px;
  max-width: 360px;
}
.sitios-system-filter {
  flex: 0 1 260px;
  max-width: 280px;
}
.sitio-main-cell {
  display: flex;
  flex-direction: column;
  min-width: 180px;
}
.sitio-main-text {
  font-weight: 600;
}
.sitio-secondary-text {
  color: rgba(0, 0, 0, 0.55);
  font-size: 0.82rem;
  line-height: 1.2;
  margin-top: 2px;
}
.sitio-status-switch {
  display: flex;
  justify-content: center;
}
.sitio-status-switch .v-input {
  flex: 0 0 auto;
}
.sitio-enabled-row {
  align-items: center;
  display: flex;
  gap: 8px;
}
.sitio-detail-row {
  background-color: #fff;
  cursor: default;
  padding: 0 !important;
}
.sitio-detail-table-wrap {
  margin: 0 8px 12px 18px;
  max-width: calc(100% - 26px);
  overflow-x: auto;
}
.sitio-detail-table {
  background-color: #fff;
  border-collapse: collapse;
  color: rgba(0, 0, 0, 0.78);
  min-width: 100%;
  table-layout: auto;
}
.sitio-detail-table th {
  background-color: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  color: rgba(0, 0, 0, 0.54);
  font-size: 0.75rem;
  font-weight: 600;
  padding: 7px 14px;
  text-align: left;
  white-space: nowrap;
}
.sitio-detail-table td {
  font-size: 0.84rem;
  line-height: 1.35;
  max-width: 360px;
  overflow-wrap: anywhere;
  padding: 8px 14px 9px;
  vertical-align: top;
}
.sitio-sensitive-value {
  align-items: center;
  display: inline-flex;
  gap: 8px;
  justify-content: flex-start;
  max-width: 100%;
  min-width: 0;
}
.sitio-sensitive-value span {
  flex: 0 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sitio-sensitive-value .v-icon {
  flex: 0 0 auto;
}
.sitio-detail-empty {
  color: rgba(0, 0, 0, 0.55);
  font-style: italic;
}
.sitio-search-hit {
  background-color: #fff176;
  border-radius: 2px;
  color: inherit;
  padding: 0 1px;
}
.label {
  opacity: 0.7;
}
/* .v-input.v-input--is-disabled {
  color: #000 !important;
  opacity: 1 !important;
}
.v-data-table .v-input.v-input--is-disabled input {
  color: #000 !important;
  opacity: 1 !important;
}
.v-data-table .v-input.v-input--is-disabled .v-select__selections {
  color: #000 !important;
  opacity: 1 !important;
}

.v-input.v-input--is-disabled .v-input__control {
  background-color: #f5f5f5 !important;
  opacity: 1 !important;
}

.v-input.v-input--is-disabled .v-input__control .v-input__slot input {
  color: #000 !important;
}
.v-input.v-input--is-disabled .v-input__control .v-select__selections {
  color: #000 !important;
} */
</style>
